<template id="home-dashboard">
  <section class="mt-2">
    <div class="card m-3">
      <div class="card-header d-flex justify-content-between">Exploratory Dashboard
<!--        <a class="txt-color-white right-padding-50"
           @click="commentBox()">
          <i class="fa fa-lg fa-comments"></i>
        </a>-->
      </div>
      <div class="card-deck m-2">
        <template v-if="call">
          <dc-vizlet v-for="(r,index) in homeData" v-bind:key="index" :dc-viz="r"></dc-vizlet>
        </template>
      </div>
    </div>
  </section>
</template>
<script>

//import axios from 'axios'

// import {bus} from "@/bus"
import dcVizlet from '@/components/dc-vizlet-dyn'

export default {
  name: "home-dashboard",
  components: {dcVizlet},

  data: () => ({

    call: null,
    res: "",
    levelOnePeriodData: [],
    annotations: [],
    filterPeriodLevel1: '',
    filterPeriodLevel2: 'quarterly',
    //filterPeriodLevel2: 'weekly',
    //filterPeriodLevel2: 'monthly',
    searching: false,
    annotationTitle: '',
    reportTitle: '',
    dataSqlId: '',
    viztypeClassName: '',
    homeData: {},
    allSummaryData: null
  }),
  computed: {},
  created() {
    this.loadHomeConfig()

    /*  bus.$on('banner-changed', (f) => {
          this.filterPeriodLevel1 = f['l1']
          this.filterPeriodLevel2 = f['l2']
          console.log('received event', f)
          setTimeout(() => {
              this.loadHomeConfig()
              //this.dcSummaryCharts()
          }, 1000)
      })*/
    this.listenToRouter()
  },
  methods: {
    periodLOne: function () {
      this.filterPeriodLevel2 = 'quarterly'
      //this.filterPeriodLevel2 = 'weekly'
      //this.filterPeriodLevel2 = 'monthly'
      this.dcSummaryCharts()
      //  this.updateReportData()
    },
    periodLTwo: function () {
      this.dcSummaryCharts()
    },
    loadHomeConfig: async function () {
      console.log('dc-dash', 'load state');
      await this.$store.dispatch("loadState")
        this.configData = this.$store.state.fwConfigScreenElement
        let submenuParam = this.$route.params.submenuId
        //let submenuParam = this.$store.state.user.userRoleRestriction.homeDashboardMenuId
        console.log("Route Param", submenuParam)
        this.homeData = this.configData.filter(r => r.menuId === submenuParam)
        console.log("All Home config data are:", this.homeData)

        let allViztypeData = this.$store.state.vizType;
        let viztypeData = allViztypeData.filter((t) => t.viztypeId === 'V77')[0];
        this.dataSqlId = this.homeData[0].datasqlId
        this.viztypeClassName = viztypeData.viztypeClassName
        console.log("vizClassName ", this.viztypeClassName)

        console.log("ALl vizData is", this.configData, this.dataSqlId, this.viztypeClassName)
        //this.loadSummary()
        this.$commonFn.crossfilterDatafetch(this.dataSqlId, this.viztypeClassName).then(() => {
          this.call = 'true'
        });
    },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.call = null
        $this.homeData = {}
        setTimeout(() => {
          $this.loadHomeConfig()

        }, 300)

      })
    }
  }
}
</script>
